module.exports = __webpack_public_path__ + "img/Tail_feathers_MetalRoughness.8a22c97.jpg";